// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"132":"b4890bc3","354":"85203f39","838":"02dd2ba7","912":"9c5ee876"}[chunkId] + ".js";
};